<template>
  <SectionCard
    id="case"
    :isPcFlag="isPcFlag"
    title="客户案例"
    bgColor="#F6F7F9"
  >
    <div class="case-content">
      <img v-if="isPcFlag" src="@/assets/images/landing-signet/logo_wall.png" alt="" />
      <img v-else src="@/assets/images/landing-signet/h5_logo_wall.png" alt="">
    </div>
  </SectionCard>
</template>

<script>
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    dataList: Array,
  },
  components: {
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
  },
  data() {
    return {
      m: 0,
    }
  },
}
</script>

<style lang="less" scoped>
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
</style>